import {defineMessages} from 'react-intl';

export default defineMessages({
	expires: {
		id: 'orders.details.payment.expires',
		defaultMessage: 'Expires',
	},
	amount: {
		id: 'orders.details.payment.amount',
		defaultMessage: 'AMOUNT: '
	},
});
